module.exports = __webpack_public_path__ + "img/game_modes_scroll.72d5bc56.svg";